import { useAtom } from "jotai";
import { useHydrateAtoms } from "jotai/utils";
import { questionnaireFormUrlAtom } from "../../store";

export const useSetQuestionnaireFormUrl = (url?: string) => {
  useHydrateAtoms([[questionnaireFormUrlAtom, url]]);
};

export const useQuestionnaireFormUrl = (): string => {
  const serverUrl = useAtom(questionnaireFormUrlAtom);

  // Handle SSR: use serverUrl if window is not available
  if (typeof window === "undefined") {
    return serverUrl[0] || "/";
  }

  return window?.location?.pathname ?? serverUrl[0];
};
